import m from "mithril"
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import {Notification} from "@nebularstreams/libmui"
import {setNotifyUpdate, setReturnToLoginHandler, loadPersistedAuth} from "./Api";

import AuthScreen from "./ui/AuthScreen";
import LauncherScreen from "./ui/LauncherScreen";
import RemixScreen from "./ui/remix/RemixScreen";
import WatermarkScreen from "./ui/WatermarkScreen";
import ReplayScreen from "./ui/ReplayScreen";
import RecordScreen from "./ui/RecordScreen";
import ChromaKeyScreen from "./ui/ChromaKeyScreen";
import ChromaKeyUploadScreen from "./ui/ChromaKeyUpload";
import ThumbnailsScreen from "./ui/ThumbnailsScreen";

import "./ui/css/skin.css";
import "./ui/css/header.css";
import "./ui/css/launcher.css";
import "./ui/css/body.css";
import "./ui/css/cardie.css";
import "./ui/css/fontawesome.css";
import "./ui/css/playlist.css";
import "./ui/css/chromakey.css";
import "./ui/css/watermark.css";

function startApp(target, appMetadata) {
	m.route(
		document.getElementById(target),
		appMetadata.default || "/",
		appMetadata.routes
	);
}

loadPersistedAuth();

function startUi() {

	startApp("ui", {
		default: "/",
		routes: {
			"/": AuthScreen,
			"/:key": LauncherScreen,
			"/:orga/watermark": WatermarkScreen,
			"/:orga/remix": RemixScreen,
			"/:orga/remix/:key": RemixScreen,
			"/:orga/replay": ReplayScreen,
			"/:orga/replay/:key": ReplayScreen,
			"/:orga/chromakey": ChromaKeyUploadScreen,
			"/:orga/chromakey/:key": ChromaKeyScreen,
			"/:orga/chromakey/:key/:secondary": ChromaKeyScreen,
			"/:orga/rec": RecordScreen,
			"/:orga/rec/:key": RecordScreen,
			"/:orga/thumbnails": ThumbnailsScreen,
			"/:orga/thumbnails/:key": ThumbnailsScreen,
		}
	});
}

function domcontentloaded(doStuff) {
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", doStuff);
	} else {
		doStuff();
	}
}

function boot() {

	m.route.prefix = "?";

	dayjs.extend(relativeTime)

	// handlers so controller is 100% independent of presentation
	setNotifyUpdate((text) => {
		if (text) Notification.add(text);
		m.redraw()
	});
	setReturnToLoginHandler(() => m.route.set("/"));

	domcontentloaded(startUi);

}

////////////////////////////////////////////////

boot();

////////////////////////////////////////////////
